import { render, staticRenderFns } from "./autocomplete-author.vue?vue&type=template&id=479969e2&"
import script from "./autocomplete-author.vue?vue&type=script&lang=js&"
export * from "./autocomplete-author.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports